import * as React from 'react';
import Box from '@mui/material/Box';
import { useColorScheme } from '@mui/material/styles';

const HEIGHT = 60;
const WIDTH = 60;

type Color = 'dark' | 'light' | 'mono';

export interface LogoProps {
  color?: Color;
  emblem?: boolean;
  height?: number;
  width?: number;
}

export function Logo({ color = 'dark', emblem, height = HEIGHT, width = WIDTH }: LogoProps): React.JSX.Element {
  let url: string;

  if (emblem) {
    if (color === 'light') {
      url = '/assets/logo-emblem.svg';
    } else if (color === 'dark') {
      url = '/assets/logo-emblem--dark.svg';
    } else {
      url = '/assets/logo-emblem--dark.svg';
    }
  } else {
    if (color === 'light') {
      url = '/assets/logo.svg';
    } else if (color === 'dark') {
      url = '/assets/logo--dark.svg';
    } else {
      url = '/assets/logo--mono.svg';
    }
  }

  return <Box alt="logo" component="img" height={height} src={url} width={width} />;
}

export interface DynamicLogoProps {
  colorDark?: Color;
  colorLight?: Color;
  emblem?: boolean;
  height?: number;
  width?: number;
}

export function DynamicLogo({
  colorDark = 'light',
  colorLight = 'dark',
  height = HEIGHT,
  width = WIDTH,
  ...props
}: DynamicLogoProps): React.JSX.Element {
  const { colorScheme } = useColorScheme();
  const color = colorScheme === 'dark' ? colorDark : colorLight;

  return (
      <Logo color={color} height={height} width={width} {...props} />
  );
}
